$ = require 'jquery'
_ = require 'underscore'

React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'

{ BoardTemplateBadge } = require 'app/src/components/BoardTemplateBadge'

module.exports.isTemplate = ->
  @templateFlagEnabled && @model.isTemplate()

module.exports.renderBoardTemplateReactSection = ->
  $('.js-board-template-badge').append(@boardTemplateBadgeDiv)
  ReactDOM.render(@boardTemplateBadgeComponent, @boardTemplateBadgeDiv)

module.exports.renderBoardTemplateBadge = ->
  if !@model.isTemplate()
    if @boardTemplateBadgeDiv
      ReactDOM.unmountComponentAtNode(@boardTemplateBadgeDiv)
      @boardTemplateBadgeDiv = null
      @boardTemplateBadgeComponent = null
    return

  previouslyRendered = @boardTemplateBadgeDiv? && @boardTemplateBadgeComponent?
  if !previouslyRendered
    # Defer here since the target div that is being rendered by Backbone may
    # not be available yet.
    _.defer =>
      @boardTemplateBadgeComponent = React.createElement(BoardTemplateBadge)
      @boardTemplateBadgeDiv = document.createElement('div')
      @renderBoardTemplateReactSection()
  else
    @renderBoardTemplateReactSection()
